import DataProvider from "../../data_provider/DataProvider";


/**
 * @author Kim YoungJun
 * @date 2025-04-02
 * @description 주소필드를 추론하는 API에 POST Request 호출
 * @param data string[][]
 * @returns number[]
 */
export const validateAddressField = async (data: string[][]): Promise<number[]> => {
    
    const query = data.slice(1, 6);

    try {
        
        const response = await DataProvider.ValidateAddress({
            query: JSON.stringify(query)
        });

        const result: number[] = JSON.parse(response.result.value);

        console.log("주소 필드 판별 결과:", result);
        console.log("추론된 주소 필드 인덱스:", result.map((v, i) => (v > 0 ? i : -1)).filter(i => i !== -1));

        return result.map((v, i) => (v > 0 ? i : -1)).filter(i => i !== -1);

    } catch (e) {
        console.error('주소 필드 판별 실패:', e);
        return [];
    }
};